import { listTags } from '../../action/tags'

export const tagsLoader = async () => {

    await listTags()

}
